import { Logger } from "../utils/Logger";
var SettingsEnum;
(function (SettingsEnum) {
    SettingsEnum["lastLoginUsername"] = "lastLoginUsername";
    SettingsEnum["enableUiAnimations"] = "enableUiAnimations";
    SettingsEnum["isUiSoundMuted"] = "isUiSoundMuted";
    SettingsEnum["uiSoundVolume"] = "uiSoundVolume";
    SettingsEnum["isSoundMuted"] = "isSoundMuted";
    SettingsEnum["soundVolume"] = "soundVolume";
    SettingsEnum["menuPositionAngle"] = "menuPositionAngle";
    SettingsEnum["broadcastMenuRotation"] = "menuRotationQuaternion";
    SettingsEnum["videoMenuRotation"] = "videoMenuRotationQuaternion";
    SettingsEnum["lastTipsButtonIndex"] = "lastTipsButtonIndex";
    SettingsEnum["customTipsAmount"] = "customTipsAmount";
    SettingsEnum["wasOnboardingViewed"] = "wasOnboardingViewed";
    SettingsEnum["wasStreamTypesAnnouncementViewed"] = "wasStreamTypesAnnouncementViewed";
    SettingsEnum["wasFavoritesAnnouncementViewed"] = "wasFavoritesAnnouncementViewed";
    SettingsEnum["wasRelatedBroadcastsAnnouncementViewed"] = "wasRelatedBroadcastsAnnouncementViewed";
    SettingsEnum["wasVodAnnouncementViewed"] = "wasVodAnnouncementViewed";
    SettingsEnum["wasMessengerAnnouncementViewed"] = "wasMessengerAnnouncementViewed";
    SettingsEnum["wasPtAnnouncementViewed"] = "wasPtAnnouncementViewed";
    SettingsEnum["doNotShowVoiceToTextOnboarding"] = "doNotShowVoiceToTextOnboarding";
    SettingsEnum["showToysMenuNotification"] = "showToysMenuNotification";
    SettingsEnum["showHelp"] = "showHelp";
    SettingsEnum["newFeatureMarkVisibility"] = "newFeatureMarkVisibility";
})(SettingsEnum || (SettingsEnum = {}));
export class Settings {
    static getInstance() {
        if (!settingsInstance) {
            settingsInstance = new Settings();
        }
        return settingsInstance;
    }
    constructor() {
        this.common = new CommonSettings();
        this.common.writeDefaultCommonSettings(); // Keep this line until we make a User Settings Dialog.
        this.login = new LoginSettings();
        this.broadcast = new BroadcastSettings();
        this.onboarding = new OnboardingSettings();
        this.streamTypesAnnouncement = new StreamTypesAnnouncementSettings();
        // this.favoritesAnnouncement = new FavoritesAnnouncementSettings();
        // this.relatedBroadcastsAnnouncement = new RelatedBroadcastsAnnouncementSettings();
        // this.vodAnnouncement = new VodAnnouncementSettings();
        // this.messengerAnnouncement = new MessengerAnnouncementSettings();
        this.ptAnnouncement = new PtAnnouncementSettings();
        this.newFeature = new NewFeatureSettings();
    }
}
let settingsInstance;
class LoginSettings {
    get lastLoginUsername() {
        return get(SettingsEnum.lastLoginUsername, "");
    }
    set lastLoginUsername(value) {
        set(SettingsEnum.lastLoginUsername, value);
    }
}
class CommonSettings {
    writeDefaultCommonSettings() {
        const enableUiAnimations = localStorage[SettingsEnum.enableUiAnimations];
        if (enableUiAnimations === undefined) {
            this.enableUiAnimations = this.enableUiAnimations; // (write default value)
        }
        const isUiSoundMuted = localStorage[SettingsEnum.isUiSoundMuted];
        if (isUiSoundMuted === undefined) {
            this.isUiSoundMuted = this.isUiSoundMuted; // (write default value)
        }
        const uiSoundVolume = localStorage[SettingsEnum.uiSoundVolume];
        if (uiSoundVolume === undefined) {
            this.uiSoundVolume = this.uiSoundVolume; // (write default value)
        }
    }
    get enableUiAnimations() {
        return get(SettingsEnum.enableUiAnimations, true);
    }
    set enableUiAnimations(value) {
        set(SettingsEnum.enableUiAnimations, value);
    }
    get isUiSoundMuted() {
        return get(SettingsEnum.isUiSoundMuted, false);
    }
    set isUiSoundMuted(value) {
        set(SettingsEnum.isUiSoundMuted, value);
    }
    get uiSoundVolume() {
        return get(SettingsEnum.uiSoundVolume, 1.0);
    }
    set uiSoundVolume(value) {
        set(SettingsEnum.uiSoundVolume, value);
    }
}
class BroadcastSettings {
    get isSoundMuted() {
        return get(SettingsEnum.isSoundMuted, false);
    }
    set isSoundMuted(value) {
        set(SettingsEnum.isSoundMuted, value);
    }
    get soundVolume() {
        return get(SettingsEnum.soundVolume, 1.0);
    }
    set soundVolume(value) {
        set(SettingsEnum.soundVolume, value);
    }
    get broadcastMenuRotation() {
        return get(SettingsEnum.broadcastMenuRotation, null);
    }
    set broadcastMenuRotation(value) {
        set(SettingsEnum.broadcastMenuRotation, value);
    }
    get videoMenuRotation() {
        return get(SettingsEnum.videoMenuRotation, null);
    }
    set videoMenuRotation(value) {
        set(SettingsEnum.videoMenuRotation, value);
    }
    // get menuPosition(): Vector3
    // {
    //     return get<Vector3>(SettingsEnum.menuPosition, Vector3.Zero());
    // }
    // set menuPosition(value: Vector3)
    // {
    //     set(SettingsEnum.menuPosition, value);
    // }
    get defaultTipsButtonIndex() {
        return 1;
    }
    get lastTipsButtonIndex() {
        return get(SettingsEnum.lastTipsButtonIndex, this.defaultTipsButtonIndex);
    }
    set lastTipsButtonIndex(value) {
        set(SettingsEnum.lastTipsButtonIndex, value);
    }
    get customTipsAmount() {
        return get(SettingsEnum.customTipsAmount, 0);
    }
    set customTipsAmount(value) {
        set(SettingsEnum.customTipsAmount, value);
    }
    get doNotShowVoiceToTextOnboarding() {
        return get(SettingsEnum.doNotShowVoiceToTextOnboarding, false);
    }
    set doNotShowVoiceToTextOnboarding(value) {
        set(SettingsEnum.doNotShowVoiceToTextOnboarding, value);
    }
    get showToysMenuNotification() {
        return get(SettingsEnum.showToysMenuNotification, true);
    }
    set showToysMenuNotification(value) {
        set(SettingsEnum.showToysMenuNotification, value);
    }
    get showHelp() {
        return get(SettingsEnum.showHelp, true);
    }
    set showHelp(value) {
        set(SettingsEnum.showHelp, value);
    }
}
class OnboardingSettings {
    get wasViewed() {
        return get(SettingsEnum.wasOnboardingViewed, false);
    }
    set wasViewed(value) {
        set(SettingsEnum.wasOnboardingViewed, value);
    }
}
class AnnouncementSettings {
    get wasViewed() {
        const isNewFeature = new Date() < this._getFinalDate();
        if (!isNewFeature)
            return true;
        return get(this._getSettingName(), false);
    }
    set wasViewed(value) {
        set(this._getSettingName(), value);
    }
}
class StreamTypesAnnouncementSettings extends AnnouncementSettings {
    constructor() {
        super(...arguments);
        this._getSettingName = () => SettingsEnum.wasStreamTypesAnnouncementViewed;
        this._getFinalDate = () => new Date(2023, 10, 3); //2023-nov-03
    }
}
// class FavoritesAnnouncementSettings extends AnnouncementSettings {
//     protected _getSettingName = (): SettingsEnum => SettingsEnum.wasFavoritesAnnouncementViewed;
//     protected _getFinalDate = (): Date => new Date(2025, 0, 1); //2025-jan-01
// }
// class RelatedBroadcastsAnnouncementSettings extends AnnouncementSettings {
//     protected _getSettingName = (): SettingsEnum => SettingsEnum.wasRelatedBroadcastsAnnouncementViewed;
//     protected _getFinalDate = (): Date => new Date(2025, 0, 1); //2025-jan-01
// }
// class VodAnnouncementSettings extends AnnouncementSettings {
//     protected _getSettingName = (): SettingsEnum => SettingsEnum.wasVodAnnouncementViewed;
//     protected _getFinalDate = (): Date => new Date(2025, 0, 1); //2025-jan-01
// }
// class MessengerAnnouncementSettings extends AnnouncementSettings {
//     protected _getSettingName = (): SettingsEnum => SettingsEnum.wasMessengerAnnouncementViewed;
//     protected _getFinalDate = (): Date => new Date(2025, 2, 1); //2025-mar-01
// }
class PtAnnouncementSettings extends AnnouncementSettings {
    constructor() {
        super(...arguments);
        this._getSettingName = () => SettingsEnum.wasPtAnnouncementViewed;
        this._getFinalDate = () => new Date(2035, 2, 1); //2035-mar-01
    }
}
class NewFeatureSettings {
    getMarkVisibility(featureName) {
        const value = localStorage[SettingsEnum.newFeatureMarkVisibility + featureName];
        return (value === undefined || value === null) ? true : JSON.parse(value) === true;
    }
    setMarkVisibility(featureName, value) {
        localStorage[SettingsEnum.newFeatureMarkVisibility + featureName] = JSON.stringify(value);
    }
}
function get(name, defaultValue) {
    const value = localStorage[name];
    if (value === undefined)
        return defaultValue;
    try {
        return JSON.parse(value);
    }
    catch {
        Logger.error(`LocalStorage error: corrupt value in \'${name}\' key.`);
        return defaultValue;
    }
}
function set(name, value) {
    localStorage[name] = JSON.stringify(value);
}
